export const HOUSEHOLD_ASSIST_MIN_QUERY_LENGTH = 2;
export const HOUSEHOLD_ASSIST_RATE_LIMIT_COOLDOWN_MS = 60_000;
